export const Color = {
    DOVISH_PRIMARY: "#08CF9F",
    BACKGROUND_OFF_WHITE: "#FBFBFB",
    ORANGE: "#FFAD62"
};
